import { render, staticRenderFns } from "./spells_dragable.vue?vue&type=template&id=1641c616&scoped=true&"
import script from "./spells_dragable.vue?vue&type=script&lang=js&"
export * from "./spells_dragable.vue?vue&type=script&lang=js&"
import style0 from "./spells_dragable.vue?vue&type=style&index=0&id=1641c616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641c616",
  null
  
)

export default component.exports